export default __webpack_public_path__ + "static/media/help_speech_bubble.7b03b201.png";